"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMatchingAdvisorElements = exports.DISTANCE_IN_METERS = exports.DISTANCE_MATRIX_MAX = exports.splitArray = exports.findCommonElements = exports.parseAdvisorStates = exports.parseAdvisorSettings = void 0;
var parseAdvisorSettings = function (dataset) {
    var decodedSettings = JSON.parse(dataset);
    if (!Array.isArray(decodedSettings) || !decodedSettings.length) {
        return [];
    }
    return decodedSettings.map(function (val) { return parseInt(val); });
};
exports.parseAdvisorSettings = parseAdvisorSettings;
var parseAdvisorStates = function (dataset) {
    var decodedSettings = JSON.parse(dataset);
    if (!Array.isArray(decodedSettings) || !decodedSettings.length) {
        return [];
    }
    return decodedSettings;
};
exports.parseAdvisorStates = parseAdvisorStates;
var findCommonElements = function (arr1, arr2) { return arr1.some(function (item) { return arr2.includes(item); }); };
exports.findCommonElements = findCommonElements;
var splitArray = function (array, n) {
    if (n === void 0) { n = exports.DISTANCE_MATRIX_MAX; }
    var arr = array.slice(0);
    var res = [];
    while (arr.length) {
        res.push(arr.splice(0, n));
    }
    return res;
};
exports.splitArray = splitArray;
exports.DISTANCE_MATRIX_MAX = 25;
exports.DISTANCE_IN_METERS = 96561; // 60 miles
var getMatchingAdvisorElements = function (matchingAdvisors) { return matchingAdvisors.map(function (advisor) { return advisor.element; }); };
exports.getMatchingAdvisorElements = getMatchingAdvisorElements;
